import { useTranslation } from 'react-i18next';
import { getI18n } from './i18n';
import type {
	LocaleValues,
	TranslationNamespace,
	TypedLocalize,
} from './translation.types';

export const useLocale = <N extends TranslationNamespace>(
	code: N
): { t: TypedLocalize<N> } => {
	const { t: translate } = useTranslation();
	const t = (key: string, values?: LocaleValues): string => {
		const isLoaded = getI18n().hasLoadedNamespace(code);
		if (!isLoaded) {
			return key;
		}

		return translate(key, { ns: code, ...values });
	};

	return { t };
};
